@if (showSplash) {
	<app-splash (dismissed)="onSplashDismissed()"></app-splash>
} @else {
	@if (vo$ | async; as vo) {
		<header>
			<!-- Header content goes here -->
			<mat-toolbar color="primary" class="app-console__header">
				<div class="available-instance-modules">
					@if (vo.userAvailableInstances.size !== 0) {
						<button mat-icon-button aria-label="dc-console-menu" [matMenuTriggerFor]="moduleActions">
							<mat-icon [svgIcon]="DcIcons.Menu"></mat-icon>
						</button>
						<mat-menu #moduleActions="matMenu">
							<ng-template matMenuContent let-data>
								@for (instance of vo.userAvailableInstances | toArray; track instance.id) {
									<a [href]="instance.publicUrl"
										 mat-menu-item
										 target="_blank">
										<div class="instance-modules">
											<ng-container
												[ngTemplateOutlet]="moduleLogo"
												[ngTemplateOutletContext]="{$implicit: instance.type }"></ng-container>
											<span>{{ instance.title | truncate: 25: 1: 'end' }}</span>
										</div>
									</a>
								}
							</ng-template>
						</mat-menu>
					}
				</div>

				<button mat-icon-button aria-label="dc-console-icon">
					<mat-icon [svgIcon]="DcIcons.DcConsoleModule"></mat-icon>
				</button>

				<span i18n="@@general.app.header.title">title</span>
				<span class="header-spacer"></span>

				<div class="profile">
					<button mat-icon-button aria-label="dc-console-user-menu" [matMenuTriggerFor]="actions">
						<app-avatar [avatar]="vo.userAvatar" [withTooltip]="true" ></app-avatar>
					</button>
					<mat-menu #actions="matMenu">
						<ng-template matMenuContent let-data>
							@for (a of profileActions; track a.actionName) {
								<button
									id="{{ a.actionName }}-btn"
									(click)="a.action(data)"
									mat-menu-item>
									<mat-icon *ngIf="a.icon" [svgIcon]="a.icon"></mat-icon>
									<span>{{ a.description }}</span>
								</button>
							}
						</ng-template>
					</mat-menu>
				</div>
			</mat-toolbar>
		</header>

		<nav>
			<!-- Navigation menu content goes here -->
			<ul class="app-nav-links">
				@for (nav of navLinks; track nav.label) {
					<li id="{{nav.iconName}}"
							[routerLinkActive]="'active'"
							[routerLinkActiveOptions]="{ exact: false }">
						<a mat-subheader [routerLink]="nav.path">
						<span [matTooltip]="nav.label"
									matTooltipPosition="right">
							@if(nav.iconName) {
								<mat-icon [svgIcon]="nav.iconName" class="app-console__nav__icon"></mat-icon>
							} @else {
								{{nav.label}}
							}
						</span>
						</a>
					</li>
				}
			</ul>
		</nav>

		<main>
			<!-- Main content goes here -->
			<router-outlet></router-outlet>
		</main>
	}
}

<ng-template #moduleLogo let-type>
	@switch (type) {
		@case (ModuleInstanceType.Console) {
			<mat-icon class="module-logo" [svgIcon]="DcIcons.DcConsoleModule"></mat-icon>
		}
		@case (ModuleInstanceType.Core) {
			<mat-icon class="module-logo" [svgIcon]="DcIcons.DcCoreModule"></mat-icon>
		}
		@case (ModuleInstanceType.DcMarketplace) {
			<mat-icon class="module-logo" [svgIcon]="DcIcons.DcMaestroModule"></mat-icon>
		}
	}
</ng-template>
